module.exports = __webpack_public_path__ + "img/emamReza.38683c51.png";